// extracted by mini-css-extract-plugin
export default {"lds-ring":"Spinner_lds-ring__E+Azo","small":"Spinner_small__9Q44A"};